import * as c from '../constants/FilterConstants'

export const setApprovalRequestsFilter = (filterOn, arType) => dispatch => {
  switch (filterOn) {
    case c.APPROVAL_REQUEST_FILTERS.open.value:
      dispatch({ type: c.SET_APPROVAL_REQUEST_FILTER_OPEN, payload: { arType } })
      break

    case c.APPROVAL_REQUEST_FILTERS.closed.value:
      dispatch({ type: c.SET_APPROVAL_REQUEST_FILTER_CLOSED, payload: { arType } })
      break

    case c.APPROVAL_REQUEST_FILTERS.all.value:
      dispatch({ type: c.SET_APPROVAL_REQUEST_FILTER_ALL, payload: { arType } })
      break
  }
}

export const setApprovalRequestsGroupByAICode = (val, arType) => dispatch => {
  dispatch({
    type: c.SET_APPROVAL_REQUEST_GROUP_BY_AI_CODE,
    payload: { arType, groupByAICode: val },
  })
}

export const setApprovalRequestsDistantSchools = (val, arType) => dispatch => {
  dispatch({
    type: c.SET_APPROVAL_REQUEST_DISTANT_SCHOOLS,
    payload: { arType, filterDistantSchools: val },
  })
}

export const setApprovalRequestAiCodeFilter = (val, arType) => dispatch => {
  dispatch({
    type: c.SET_APPROVAL_REQUEST_AI_CODE_FILTER,
    payload: { arType, filterAiCode: val },
  })
}
